import { Link } from "react-router-dom";
import SEOHead from "@/components/feature/SEOHead";

export default function NotFound() {
  return (
    <>
      <SEOHead
        title="404 - 页面未找到"
        description="抱歉，您访问的页面不存在。请返回韩漫之家首页，继续浏览免费韩漫资源。"
        keywords="韩漫之家, 404, 页面未找到"
        canonicalUrl="/404"
      />
      <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center px-4">
        <div className="text-center">
          <div className="text-7xl md:text-9xl font-bold text-primary-500 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
            404
          </div>
          <h1 className="text-xl md:text-2xl font-semibold text-foreground-950 mb-3">
            页面未找到
          </h1>
          <p className="text-sm text-foreground-500 mb-8 max-w-md mx-auto">
            抱歉，您访问的页面不存在或已被移除。请返回首页继续浏览精彩韩漫内容。
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            返回首页
          </Link>
        </div>
      </div>
    </>
  );
}